var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgGear = function SvgGear(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 22.313,
    viewBox: "0 0 24 22.313",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun_716640_cc",
    transform: "translate(145.5 -46.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16693",
    "data-name": "Group 16693",
    transform: "translate(-145 47)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9703",
    "data-name": "Path 9703",
    d: "M17.31,960.362l-.522,2.664a9.427,9.427,0,0,0-1.463.563l-2.413-1.538-3.1,2.87,1.669,2.228a7.981,7.981,0,0,0-.608,1.356L8,968.989v4.06l2.875.484a7.98,7.98,0,0,0,.616,1.356l-1.677,2.228,3.1,2.87,2.4-1.538a9.449,9.449,0,0,0,1.472.563l.522,2.664H21.69l.522-2.664a9.381,9.381,0,0,0,1.463-.563l2.4,1.538,3.1-2.87-1.669-2.228a7.981,7.981,0,0,0,.608-1.348L31,973.048v-4.06l-2.884-.484a7.98,7.98,0,0,0-.6-1.348l1.66-2.236-3.1-2.87-2.4,1.538a9.368,9.368,0,0,0-1.463-.563l-.522-2.664ZM19.5,966.2a4.835,4.835,0,1,1,0,9.641,4.835,4.835,0,1,1,0-9.641Zm0,.507a4.326,4.326,0,1,0,0,8.627,4.326,4.326,0,1,0,0-8.627Z",
    transform: "translate(-8 -960.362)",
    fill: "rgba(0,0,0,0)",
    stroke: "#fff",
    strokeWidth: 1
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgGear, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/gear.bae53ebb.svg";
export { ForwardRef as ReactComponent };